export default __webpack_public_path__ + "static/2247-eb7c8eecec421e9f46fb584ee25bd8d8.gif";